import { http } from "../../../services/http.service";

export const meApi = () =>
  http({ url: "super-users/me", method: "GET", auth: true });
